import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import axios from 'axios'
import { useEffect } from 'react'
import { Input as AntInput, Select as AntSelect } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import ReactPaginate from 'react-paginate';
import config from '../../../config';
import { getMarques, getTailles } from '../../../services/marqueService'
import { NdoePage, NdoePageHeader, NdoeImage, NdoeLoading, NdoeEmpty } from '../../../components/ndoe';
import { optionsCouleursParFamille } from '../../../components/ndoe/couleurGroupes';
import '../../../components/ndoe/ndoeCatalogue.css';
// Même feuille de style que « Photos à partager » : c'est la référence visuelle
// demandée par le propriétaire, autant partager la grammaire plutôt que la copier.
import '../../photosPartage/photosPartage.css';

// /entreeStock — galerie « Nos catalogues » : on choisit un modèle pour aller
// enregistrer un arrivage (/detailReception/:id). Relook chantier #4 : même
// layout que partage-catalogue (NdoePage + grille de cartes ndoe-cat).
const CatReception = () => {
    const DOMAIN = config.REACT_APP_SERVER_DOMAIN;
    const [data, setData] = useState([]);
    const [getFamille,setGetFamille] = useState([]);
    const [getMarque,setGetMarque] = useState([]);
    const [getCible,setGetCible] = useState([]);
    const [getTaille,setGetTaille] = useState([]);
    const navigate = useNavigate();
    const [famille, setFamille] = useState(null);
    const [marque, setMarque] = useState(null);
    const [cible, setCible] = useState(null);
    const [taille, setTaille] = useState(null);
    const [couleur, setCouleur] = useState(null);
    const [getCouleur,setGetCouleur] = useState([]);
    const [getMatiere,setGetMatiere] = useState([]);
    const [matiere,setMatiere] = useState(null);
    const [tri, setTri] = useState(''); // tri décisionnel (ventes / arrivages)
    const [q, setQ] = useState('');      // recherche libre — le geste principal
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    // Map (et non Object.values) : préserve l'ordre serveur du tri même si un
    // code_variant est purement numérique (sinon les clés entières remontent en tête).
    const gmap = new Map();
    data.forEach((item) => {
      const { code_variant, ...rest } = item;
      if (!gmap.has(code_variant)) gmap.set(code_variant, { code_variant, data: [] });
      gmap.get(code_variant).data.push(rest);
    });
    const groupedData = [...gmap.values()];
    const itemsPerPage = 12;
    const totalPages = Math.ceil(groupedData.length / itemsPerPage);
    const startIndex = currentPage * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const firstDataArray = groupedData.map(obj => obj.data[0]);
    const currentData = firstDataArray?.slice(startIndex, endIndex);

    const handlePageChange = (selectedPage) => {
      setCurrentPage(selectedPage.selected);
    };

    useEffect(() => {
      const fetchData = async () => {
        try {
          const { data } = await getMarques();
          setGetMarque(data);
        } catch (error) {
          console.log(error);
        }
      };
      fetchData();
    }, [DOMAIN]);

    useEffect(() => {
      const fetchData = async () => {
        try {
          const { data } = await axios.get(`${DOMAIN}/api/produit/cible`);
          setGetCible(data);
        } catch (error) {
          console.log(error);
        }
      };
      fetchData();
    }, [DOMAIN]);

    useEffect(() => {
      const fetchData = async () => {
        try {
          const { data } = await getTailles();
          setGetTaille(data);
        } catch (error) {
          console.log(error);
        }
      };
      fetchData();
    }, [DOMAIN]);

      useEffect(() => {
        const fetchData = async () => {
          try {
            const { data } = await axios.get(`${DOMAIN}/api/produit/famille`);
            setGetFamille(data);
          } catch (error) {
            console.log(error);
          }
        };
        fetchData();
      }, [DOMAIN]);

      useEffect(() => {
        const fetchData = async () => {
          try {
            const { data } = await axios.get(`${DOMAIN}/api/produit/couleur`);
            setGetCouleur(data);
          } catch (error) {
            console.log(error);
          }
        };
        fetchData();
      }, [DOMAIN]);

      useEffect(() => {
        // Recherche différée : la frappe ne doit pas déclencher un appel par
        // lettre sur un catalogue de plusieurs centaines de modèles.
        let vivant = true;
        const minuteur = setTimeout(async () => {
          try {
            const url = `${DOMAIN}/api/produit/varianteFiltre?id_famille=${famille}&id_marque=${marque}&id_cible=${cible}&id_taille=${taille}&itemsPerPage=${itemsPerPage}&currentPage=${startIndex}&id_couleur=${couleur}&id_matiere=${matiere}${tri ? `&sort=${tri}` : ''}${q.trim() ? `&q=${encodeURIComponent(q.trim())}` : ''}`

            const { data } = await axios.get(url);
            if (!vivant) return;
            setData(Array.isArray(data) ? data : (data?.variantes || []));
            setLoading(false)
            // (Le rechargement de page sur résultat vide a été retiré : il créait
            //  une boucle de reload quand un filtre ne renvoyait aucun article.)
          } catch (error) {
            console.log(error);
            if (vivant) setLoading(false);
          }
        }, q.trim() ? 300 : 0);
        return () => { vivant = false; clearTimeout(minuteur); };
      }, [DOMAIN, famille, marque, cible, taille, itemsPerPage, startIndex, couleur, matiere, tri, q]);

      useEffect(() => {
        const fetchData = async () => {
          try {
            const { data } = await axios.get(`${DOMAIN}/api/produit/matiere`);
            setGetMatiere(data);
          } catch (error) {
            console.log(error);
          }
        };
        fetchData();
      }, [DOMAIN]);

  const filtres = [
    { key: 'famille', label: 'Catégorie', options: getFamille?.map(i => ({ value: i.id_famille, label: i.nom })), set: setFamille },
    { key: 'marque', label: 'Marque', options: getMarque?.map(i => ({ value: i.id_marque, label: i.nom })), set: setMarque },
    { key: 'cible', label: 'Cible', options: getCible?.map(i => ({ value: i.id_cible, label: i.nom_cible })), set: setCible },
    { key: 'taille', label: 'Pointure', options: getTaille?.slice().sort((a, b) => a.id_taille - b.id_taille).map(i => ({ value: i.id_taille, label: i.taille })), set: setTaille },
    // En FILTRE, le compte de nuances aide à viser : « Rose (8) ».
    { key: 'couleur', label: 'Couleur', options: optionsCouleursParFamille(getCouleur, { avecNbNuances: true }), set: setCouleur },
    { key: 'matiere', label: 'Matière', options: getMatiere?.map(i => ({ value: i.id_matiere, label: i.nom_matiere })), set: setMatiere },
  ];

  return (
    <NdoePage>
      <NdoePageHeader
        eyebrow="Réceptions"
        title="Nos catalogues"
        subtitle="Choisissez un modèle pour enregistrer un arrivage."
      />

      {/* MÊME GRAMMAIRE QUE « PHOTOS À PARTAGER » (31/07/2026) — demande du
          propriétaire : « elle pourrait davantage ressembler au menu de partage
          de photo WhatsApp ».
          Ce qui manquait n'était pas seulement l'allure : cet écran n'offrait
          QUE des listes déroulantes. Pour trouver un modèle il fallait deviner
          sa catégorie, sa marque et sa matière — ou feuilleter 61 pages. Or on
          arrive ici en sachant le NOM ou la RÉFÉRENCE de la paire qu'on reçoit,
          jamais sa taxonomie. La zone de recherche est donc DOMINANTE, comme sur
          l'écran de partage, et les filtres redeviennent un affinage. */}
      <div className="pp-filtres">
        <AntInput
          allowClear size="large" prefix={<SearchOutlined />}
          placeholder="Nom, référence, marque ou couleur du modèle…"
          value={q} onChange={(e) => { setQ(e.target.value); setCurrentPage(0); }}
          className="pp-f pp-f-q"
        />
        {filtres.map((f) => (
          <AntSelect
            key={f.key}
            mode="multiple" allowClear maxTagCount="responsive"
            placeholder={f.label} options={f.options}
            onChange={(vals) => { f.set((vals || []).join(',') || null); setCurrentPage(0); }}
            showSearch optionFilterProp="label"
            className={`pp-f ${f.key === 'taille' ? 'pp-f-pt' : ''}`}
          />
        ))}
        <AntSelect
          value={tri || ''} onChange={(v) => { setTri(v); setCurrentPage(0); }}
          className="pp-f pp-f-tri" title="Trier les modèles"
          options={[
            { value: '', label: 'Tri : A→Z' },
            { value: 'sales_desc', label: 'Meilleures ventes (90 j)' },
            { value: 'last_sale', label: 'Dernières ventes' },
            { value: 'last_receipt', label: 'Derniers arrivages' },
          ]}
        />
      </div>

      {/* Le compte, avant la grille : sur un catalogue de plusieurs centaines de
          modèles, savoir combien on regarde évite de feuilleter pour rien. */}
      {!loading && (
        <p className="pp-aide">
          <b>{groupedData.length}</b> modèle{groupedData.length > 1 ? 's' : ''}
          {(q || tri) && <> · {q ? <>recherche « {q} »</> : null}{q && tri ? ' · ' : ''}{tri ? 'trié' : ''}</>}
          {totalPages > 1 && <> · page {currentPage + 1} sur {totalPages}</>}
        </p>
      )}

      {loading ? (
        <NdoeLoading rows={4} />
      ) : currentData.length === 0 ? (
        <NdoeEmpty icon="👟" title="Aucun article" text={q ? `Rien ne correspond à « ${q} ».` : 'Aucun modèle ne correspond à ces filtres.'} />
      ) : (
        <>
          <div className="ndoe-cat-grille">
            {currentData.map((dd) => (
              <button
                type="button"
                className="ndoe-cat-carte"
                key={dd.id_varianteProduit}
                onClick={() => navigate(`/detailReception/${dd.id_varianteProduit}`)}
              >
                <div className="ndoe-cat-thumb">
                  {/* Grille fluide : voir PartageCatalogue — `sizes` obligatoire. */}
                  <NdoeImage src={dd.img} alt={dd.nom_produit || 'Article'} size="lg" sizes="200px" preview={false} />
                </div>
                <span className="ndoe-cat-ref num">{dd.code_produit || dd.code_variant || ' '}</span>
                <span className="ndoe-cat-nom" title={dd.nom_produit}>{dd.nom_produit || 'Article'}</span>
                <span className="ndoe-cat-sub">{[dd.nom_marque || dd.marque, dd.description || dd.couleur].filter(Boolean).join(' · ') || ' '}</span>
              </button>
            ))}
          </div>

          {totalPages > 1 && (
            <ReactPaginate
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              previousLabel={'Précédent'}
              nextLabel={'Suivant'}
              containerClassName={'pagination'}
              activeClassName={'active'}
              itemClass={'pointer-cursor'}
              forcePage={currentPage}
            />
          )}
        </>
      )}
    </NdoePage>
  )
}

export default CatReception
